<div class="day-group" [style.width.px]="totalWidthPx()" [style.minWidth.px]="totalWidthPx()">
  <div class="day-header" [class.today]="day().isToday">
    <div class="day-header-main">
      <span class="day-name">{{ dayNameLabel() }}</span>
      <span class="day-date">{{ dayDateLabel() }}</span>
      @if (day().isToday) {
        <span class="today-badge">heute</span>
      }
    </div>
    <div class="court-names-row">
      @for (court of visibleCourts(); track court.courtId) {
        <div class="court-name-cell" [style.width.px]="courtColumnWidth()" [title]="court.courtName">
          {{ court.courtName }}
        </div>
      }
    </div>
  </div>

  <div class="court-columns-row">
    @for (court of visibleCourts(); track court.courtId) {
      <app-court-column
        [column]="court"
        [dateStr]="day().date"
        [pxPerMinute]="pxPerMinute()"
        [intervalMinutes]="intervalMinutes()"
        [courtColumnWidth]="courtColumnWidth()"
        [maxBookableUtc]="maxBookableUtc()"
        (freeCellActivated)="onFreeCellActivated($event)"
        (freeCellDragStarted)="onFreeCellDragStarted($event)"
        (courseSessionClicked)="onCourseSessionClicked($event)" />
    }
  </div>
</div>
